(() => {
  if (window.bundleCartComponentsInitialized) return;
  window.bundleCartComponentsInitialized = true;

  function createBundleImage(component) {
    const wrapper = document.createElement('span');
    wrapper.className = 'cart-bundle__image-wrapper';
    wrapper.setAttribute('aria-hidden', 'true');

    if (component.t) {
      const image = document.createElement('img');
      image.className = 'cart-bundle__image';
      image.src = component.t;
      image.alt = '';
      image.loading = 'lazy';
      wrapper.appendChild(image);
      return wrapper;
    }

    const placeholder = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    placeholder.setAttribute('class', 'cart-bundle__image-placeholder');
    placeholder.setAttribute('viewBox', '0 0 24 24');
    placeholder.setAttribute('fill', 'none');
    placeholder.setAttribute('stroke', 'currentColor');
    placeholder.setAttribute('stroke-width', '1.5');
    placeholder.innerHTML =
      '<rect x="3" y="4" width="18" height="16" rx="2"></rect>' +
      '<circle cx="8.5" cy="9" r="1.5"></circle>' +
      '<path d="m5 17 4.5-4.5 3.5 3 2.5-2.5L19 17"></path>';
    wrapper.appendChild(placeholder);

    return wrapper;
  }

  function hydrateBundleItem(element) {
    if (element.dataset.bundleHydrated === 'true') return;

    try {
      const component = JSON.parse(element.dataset.bundleComponent);
      const quantity = Number(component.q) || 1;
      const name = component.n || 'Bundle item';

      const text = document.createElement('p');
      text.className = 'cart-bundle__name';
      text.textContent = `${quantity} × ${name}`;

      element.replaceChildren(createBundleImage(component), text);
      element.dataset.bundleHydrated = 'true';
    } catch (error) {
      console.error('Unable to render bundle component:', error);
      element.hidden = true;
    }
  }

  function updateBundleSummary(details) {
    const summary = details.querySelector('.cart-bundle__summary');
    const summaryText = details.querySelector('.cart-bundle__summary-text');
    if (!summary || !summaryText) return;

    const count = Number(summary.dataset.bundleCount) || 0;
    const noun = count === 1 ? 'item' : 'items';
    summaryText.textContent = `${details.open ? 'Hide' : 'Show'} ${count} ${noun}`;
  }

  function hydrateBundleComponents(root = document) {
    root.querySelectorAll('[data-bundle-component]').forEach(hydrateBundleItem);
    root.querySelectorAll('.cart-bundle').forEach(updateBundleSummary);
  }

  document.addEventListener(
    'toggle',
    (event) => {
      if (event.target.matches('.cart-bundle')) {
        updateBundleSummary(event.target);
      }
    },
    true
  );

  document.addEventListener('bundle-bot:bundling', (event) => {
    const active = Boolean(event.detail && event.detail.active);
    document.querySelectorAll('.drawer__bundling-banner').forEach((banner) => {
      banner.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  });

  const start = () => {
    hydrateBundleComponents();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches('[data-bundle-component], .cart-bundle')) {
            hydrateBundleComponents(node.parentElement || document);
          } else if (node.querySelector('[data-bundle-component], .cart-bundle')) {
            hydrateBundleComponents(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
